import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { MensagemService } from 'src/app/features/mensagem.service';
import { from, Observable } from 'rxjs';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { FaixaCarteiraPessoaJuridica, ValorFaixaCarteiraPessoaJuridica } from 'src/app/model/faixa-carteira-pessoa-juridica.model';
import { FaixaCarteiraPessoaJuridicaService } from '../faixa-carteira-pessoa-juridica.service';
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { Tranche } from 'src/app/model/tranche.model';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';


@Component({
    selector: 'app-faixa-carteira-pessoa-juridica-cadastro',
    templateUrl: './faixa-carteira-pessoa-juridica-cadastro.component.html',
    standalone: false
})
export class FaixaCarteiraPessoaJuridicaCadastroComponent implements OnInit {

  public agentesFinanceiros: AgenteFinanceiro[] = [];
  public valoresFaixaCarteira: ValorFaixaCarteiraPessoaJuridica[];
  public faixasCarteira: FaixaCarteiraPessoaJuridica[];
  public idAgenteFinanceiro: number;
  public valorFaixa: ValorFaixaCarteiraPessoaJuridica;
  public dataInicioValidade: Date = new Date();
  public tranches: Tranche[] = [];
  public idTranche: number;
  public mostrarLabel: boolean = false;

  constructor(
    private modalService: BnModalMessageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private mensagemService: MensagemService,
    private service: FaixaCarteiraPessoaJuridicaService,
    private trancheService: TrancheService,
    private agenteService: AgenteFinanceiroService) {
  }

  ngOnInit(): void {
    this.agenteService.getAgentesFinanceiros().subscribe (agentes => {
      this.agentesFinanceiros = agentes;
    });
    this.buscarFaixasCarteira();
    this.dataInicioValidade.setDate(this.dataInicioValidade.getDate() + 1);

    console.log(this.agentesFinanceiros)
  }

  public buscarFaixasCarteira() {
      this.service.buscarValoresFaixaCarteira().subscribe((valores: ValorFaixaCarteiraPessoaJuridica[]) => {
        this.valoresFaixaCarteira = valores;
      })
      this.service.buscarFaixasCarteira().subscribe(response => {
        this.faixasCarteira = response.resultados;
      })
      this.trancheService.getTranches().subscribe(tranches => {
        this.tranches = tranches;
        this.idTranche = this.tranches[this.tranches.length > 1 ? 1 : 0].id
      });
  }

  async salvar() {

    let dto = new FaixaCarteiraPessoaJuridica();

    if(this.idAgenteFinanceiro) {
      dto.idAgenteFinanceiro = this.idAgenteFinanceiro;
    }
    if(this.valorFaixa) {
      dto.valorFaixa = this.valorFaixa;
    }
    if(this.dataInicioValidade) {
      dto.dataInicioValidade = this.dataInicioValidade;
    }
    if(this.idTranche) {
      dto.idTranche = this.idTranche;
    }
    
    await this.service.salvarFaixaCarteira(dto).toPromise();
    this.mensagemService.adicionarMensagemSucesso('Faixa de carteira PJ cadastrada com sucesso.');
    this.voltar();
  }

  voltarParaLista() {
    if(this.idAgenteFinanceiro == null && this.valorFaixa == null) {
      this.router.navigate(["/faixa-carteira-pessoa-juridica/pesquisa"]);
    }
    else {
      this.abreModalConfirmacao('Descartar cadastro de faixa?').then(resp => {
        if(resp === true) {
          this.router.navigate(["/faixa-carteira-pessoa-juridica/pesquisa"]);
        }
      })
    }
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
        const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
        return resultadoConfimacao.value === 'ok';
    } catch (e) {
        return false;
    }
  }

  mostraLabel(option: boolean) {
    this.mostrarLabel = option;
  }

  voltar() {
    this.router.navigate(['/faixa-carteira-pessoa-juridica/pesquisa']);
  }

}
